// extracted by mini-css-extract-plugin
module.exports = {"Social":"Social_Social__1Kvq-","igtext":"Social_igtext__3aTHW"};